import { render, staticRenderFns } from "./ClientCredentialsAdd.vue?vue&type=template&id=458c18bc"
import script from "./ClientCredentialsAdd.vue?vue&type=script&lang=js"
export * from "./ClientCredentialsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports